import { useState, useEffect } from "react";
import { purchaseEnquiryService } from "../../enquiry/purchaseEnquiryService"
import { usePurchaseEnquiryModel } from "../../enquiry/purchaseEnquiryModel";
import { IPurchaseEnquiryDetail, IPurchaseEnquiryFields, IDetailList } from "../../enquiry/purchaseEnquiryType"
import { supplierMapModel, supplierMapType } from "@/utils/supplierMap";
import { momentFormat } from "@/utils/utils";
import { globalPrompt } from "@/components/message";
import useGlobalModel from "@/model/globalModel";

interface PropsType {
  printVisible: boolean;
  setPrintVisible: (visible: boolean) => void
}

export const PurchaseTable = (props: PropsType) => {
  const { printVisible, setPrintVisible } = props;
  const { descRows } = usePurchaseEnquiryModel();
  const { supplierMap, getSupplierField } = supplierMapModel();

  const [supplier, setSupplier] = useState<supplierMapType[]>([]);
  const [pageCount, setPageCount] = useState<number>(0);
  const [info, setInfo] = useState<IPurchaseEnquiryFields>([]);
  const [dataSource, setDataSource] = useState<IPurchaseEnquiryDetail[]>([]);

  const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()
  useEffect(() => {
    if (printVisible) {
      const codes = descRows.map(e => e.code);
      purchaseEnquiryService.findDetailByCodes(codes).then((res) => {
        const data = res.retData?.[0];
        setInfo(data);
        if (data != null) {
          const su = supplierMap.filter(e => data.supplierInfo.indexOf(e.code) > -1);
          setSupplier(su);
          let materialList: IDetailList[] = [];
          (data.details ?? []).forEach(detail => {
            materialList.push(detail);
          })
          if (materialList.length !== 0) {
            //setPageCount(Math.ceil(materialList.length / 60));
            setPageCount(1);
            setDataSource(materialList);
            print();
          }
          else {
            setPrintVisible(false);
            globalPrompt("message", { text: "无询价商品，不予打印！", type: "error" });
          }
        }
      })
    }
  }, [printVisible])

  const print = () => {
    const el: HTMLElement | null = document.getElementById('offerPrint-container');
    const iframe: HTMLIFrameElement = document.createElement('iframe');
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write('<link rel="stylesheet" type="text/css" href="./offerPrint.css">');
      doc.write(el?.innerHTML || '');
      doc.close();
    }

    iframe.contentWindow?.addEventListener('afterprint', () => {
      document.body.removeChild(iframe);
      setPrintVisible(false);
    });

    iframe.contentWindow?.focus();
    iframe.onload = () => {
      iframe.contentWindow?.print();
    };

    if (navigator.userAgent.indexOf("MSIE") > 0) {
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 100);
    }
  };

  return (
    <div style={{ display: 'none' }}>
      <div id="offerPrint-container" className="offerPrint-container">
        {Array.from({ length: pageCount }).map((_, pageIndex) => (
          <div key={pageIndex} >
            <div style={{ textAlign: 'center', fontSize: 18, fontFamily: "FangSong", fontWeight: 'normal', marginTop: 50 }}>
              {`${shopName}配件采购二次竞价审批表`}
            </div>
            <div style={{ margin: '10px 0px 10px 70%', fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>
              制表时间: {new Date().getFullYear()}年{String(new Date().getMonth() + 1).padStart(2, '0')}月{String(new Date().getDate()).padStart(2, '0')}日
            </div>
            <table className="mingxi" style={{ border: "1px solid black", width: "100%" }}>
              <thead>
                <tr style={{ lineHeight: 1 }}>
                  <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>序号</th>
                  <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>产品编码</th>
                  <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>产品名称</th>
                  <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>品牌</th>
                  <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>车型</th>
                  <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>型号</th>
                  <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>单位</th>
                  <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>数量</th>
                  <th colSpan={supplier.length} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>供应商评分信息</th>
                  <th colSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>最终确定供应商及价格</th>
                  <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>所属站点</th>
                  <th rowSpan={2} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>询价单号</th>
                </tr>
                <tr style={{ lineHeight: 1 }}>
                  {supplier.map((e, i) => (
                    <th key={i} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>{e.name}</th>
                  ))}
                  <th style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>比选后确定供应商</th>
                  <th style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>送货价</th>
                </tr>
              </thead>
              <tbody>
                {/* {dataSource?.slice(pageIndex * 60, (pageIndex + 1) * 60) */}
                {dataSource.map((row, rowIndex) => (
                  <tr key={rowIndex} style={{ lineHeight: 1 }}>
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{rowIndex + 1}</td>
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.materialCode}</td>
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.materialName}</td>
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.brandCode ? row.brandName : ''}</td>
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.vehicleModel}</td>
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.model}</td>
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.unitCode ? row.unitName : ''}</td>
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.num}</td>
                    {supplier.map((item) => (
                      <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.details?.filter(e => e.supplierCode === item.code)[0]?.totalScore ?? "-"}</td>
                    ))}
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{getSupplierField('code', row.supplierCode ?? "", 'name', supplier)}</td>
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.price}</td>
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.shopName}</td>
                    <td style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{row.code}</td>
                  </tr>
                ))}
                {/* {Array.from({
                  length: 60 - dataSource.slice(
                    pageIndex * 60,
                    (pageIndex + 1) * 60
                  ).length
                }).map((_, i) => (
                  <tr key={`empty-${i}`} style={{ lineHeight: 1 }}>
                    <td style={{ width: 28, fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{dataSource.slice(pageIndex * 60, (pageIndex + 1) * 60).length + i + 1}</td>
                    {Array((10 + supplier.length)).fill(null).map((_, i) => (
                      <td key={i} style={{ fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>&nbsp;</td>
                    ))}
                  </tr>
                ))} */}
              </tbody>
            </table>
            <div style={{ display: "flex", marginTop: 10, marginBottom: 5 }}>
              <div style={{ flex: 1, fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>制表人：{info?.approver}</div>
              <div style={{ flex: 1, fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>审核人：</div>
              <div style={{ flex: 1, fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>
                <span>年</span>
                <span style={{ marginLeft: 20 }}>月</span>
                <span style={{ marginLeft: 20 }}>日</span>
              </div>
              <div style={{ flex: 1, fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>主管领导：</div>
              <div style={{ flex: 1, fontSize: 8, fontFamily: "FangSong", fontWeight: 'normal' }}>
                <span>年</span>
                <span style={{ marginLeft: 20 }}>月</span>
                <span style={{ marginLeft: 20 }}>日</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};